site.boxrelated = {
	init: function() {
		$('.box-related').parents('.box').addClass('hasBoxRelated');
	}
};

site.inits.push('site.boxrelated.init()');
